import Vue from 'vue';
import VueRouter from 'vue-router';
import PaymentWrap from '@/layouts/PaymentWrap';

import PaymentMethodsListPage from '@/pages/PaymentMethodItemsList';
import FunctionalMethodItemsList from '@/pages/FunctinalMethodItemsList';

import FlowRedirectPage from '@/pages/FlowRedirectPage';
import BadRequest from '@/pages/BadRequest';
import ErrorPage from '@/pages/ErrorPage';
import PaymentInvoiceStatusPage from '@/pages/PaymentStatusPage/PaymentStatusPage';

Vue.use(VueRouter);

const initialize = (to, from, next) => {
  console.log('INIT ROUTER HOOK');
  const { currency, public_key, amount, cpi } = to.query || {};

  next();
};

const router = new VueRouter({
  mode: 'history',
  base: '/hpp',
  routes: [
    {
      path: '/',
      name: 'PaymentWrap',
      component: PaymentWrap,
      redirect: '/methods',
      beforeEnter: initialize,
      children: [
        {
          name: 'PaymentMethodsListPage',
          path: 'methods',
          component: FunctionalMethodItemsList,
        },
        {
          name: 'pm',
          path: '/pm/:pm',
          component: FlowRedirectPage,
        },
      ],
    },
    {
      name: 'PaymentStatus',
      path: '/status/:id',
      component: PaymentInvoiceStatusPage,
    },
    {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage,
    },
    {
      path: '/*',
      name: 'BadRequest',
      component: BadRequest,
    },
  ],
});

router.beforeEach((to, from, next) => {
  next();
});
export default router;
